module.exports = __webpack_public_path__ + "img/icon-maria-outlined.3c8e0217.svg";